/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { isNotNil } from '@gh/core-util';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { AbstractRestService, RestSettings } from '@gh/core-data';
import { DEFAULT_FILTER_STATE, FILTER_MAPPERS, FilterNames } from './default-filter-state';

export type FilterModel = {
  filter: any;
};

@Injectable()
export class FilterRestService extends AbstractRestService {
  private filters: Hash<any> = {};
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(name: FilterNames): Observable<any> {
    const defaultLayout = this.loadDefaultLayout(name);
    return this.httpGet(`${this.bp}/filters/${name}`, FILTER_MAPPERS[name]).pipe(
      map$((resp: FilterModel) => {
        const result = isNotNil(resp) && !!resp.filter ? resp.filter : defaultLayout;
        this.filters[name] = result;
        return result;
      }),
    );
  }

  getLocal(name: FilterNames): FilterModel {
    return this.filters[name] ? this.filters[name].filter : { filter: {} };
  }

  update(name: FilterNames, filter: any): Observable<any> {
    const filterObject = { filter: { ...this.loadDefaultLayout(name), ...filter, searchString: '' } };
    this.filters[name] = filterObject;
    return this.httpPut(`${this.bp}/filters/${name}`,
      filterObject as FilterModel,
      FILTER_MAPPERS[name],
    );
  }

  private loadDefaultLayout(name: FilterNames): any {
    return DEFAULT_FILTER_STATE[name];
  }
}
